export enum ToastType {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}

export enum NotificationType {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export interface NotificationPayload {
  payload: {
    type: ToastType;
    status?: number;
    url?: string;
    code?: number;
    message?: string;
    is_custom?: boolean;
    title: string;
  };
}

export interface SuccessNotification extends NotificationPayload {
  type: NotificationType.Success;
}

export interface InfoNotification extends NotificationPayload {
  type: NotificationType.Info;
}

export interface WarningNotification extends NotificationPayload {
  type: NotificationType.Warning;
}

export interface ErrorNotification extends NotificationPayload {
  type: NotificationType.Error;
}

export type ToasterNotification =
  SuccessNotification | InfoNotification | WarningNotification | ErrorNotification;
